import { request } from '../request'

export const authCheck = () => {
  return request.get('/auth/me')
}

export const login = (params: any) => {
  return request.post('/auth/login', {...params})
}